<template>
  <div class="products-edit-view">
    <h1
      v-if="isSuccessfullyLoaded && product.bundle"
    >{{$t('titles.editBundle')}}</h1>
    <h1 v-else>{{$t('titles.editStandard')}}</h1>
    <loader v-if="isLoading" />
    <div v-if="isSuccessfullyLoaded">
      <bundle-product-form
        :disabled="isSubmitting"
        :errors="errors"
        :values="product"
        @submit="updateBundleProduct"
        v-if="product.bundle"
      />
      <standard-product-form
        :disabled="isSubmitting"
        :errors="errors"
        :values="product"
        @submit="updateStandardProduct"
        v-else
      />
    </div>
  </div>
</template>

<script>
import BundleProductForm from '@/components/BundleProductForm';
import Loader from '@/components/Loader';
import productQuery from '@/api/queries/product.graphql';
import StandardProductForm from '@/components/StandardProductForm';
import Submittable from '@/mixins/Submittable';
import Toast from '@/helpers/Toast';
import updateBundleProductMutation
  from '@/api/mutations/update-bundle-product.graphql';
import updateStandardProductMutation
  from '@/api/mutations/update-standard-product.graphql';
import View from '@/mixins/View';

export default {
  name: 'products-edit-view',
  mixins: [
    Submittable,
    View,
  ],
  components: {
    BundleProductForm,
    Loader,
    StandardProductForm,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    isSuccessfullyLoaded() {
      return this.isLoaded && this.product;
    },
    breadcrumbs() {
      return [
        {
          key: 'edit',
          route: { name: 'edit-product', params: { id: this.id } },
          isLoading: !this.isSuccessfullyLoaded,
        },
      ];
    },
  },
  apollo: {
    product: {
      query: productQuery,
      variables() {
        return { id: this.id };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  methods: {
    prepareMedia(product) {
      const media = product.mediaObjects || [];
      // eslint-disable-next-line arrow-body-style
      product.media = media.map((medium) => {
        return {
          id: medium.id,
          isVisible: medium.isVisible,
        };
      });
      delete product.mediaObjects;
    },
    async updateStandardProduct(product) {
      const operation = await this.submitWithMutation({
        mutation: updateStandardProductMutation,
        variables: { id: this.id, product },
      });
      this.onUpdated(operation);
    },
    async updateBundleProduct(product) {
      this.prepareMedia(product);
      const operation = await this.submitWithMutation({
        mutation: updateBundleProductMutation,
        variables: { id: this.id, product },
      });
      this.onUpdated(operation);
    },
    onUpdated(operation) {
      if (operation.isValid) {
        const productName = operation.product.name;
        const message = this.$t('toasts.updated', { name: productName });
        Toast.success(message);
        this.$router.push({
          name: 'product',
          params: { id: operation.product.id },
        });
      }
    },
  },
  i18n: {
    messages: {
      de: {
        titles: {
          editBundle: 'Bundle bearbeiten',
          editStandard: 'Produkt bearbeiten',
        },
        toasts: {
          updated: 'Produkt aktualisiert: {name}',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// EditView.vue?7ca535f2